var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcExternalReconciliation = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 5 H8 a2 2 0 0 0 -2 2 V27 a2 2 0 0 0 2 2 H22 a2 2 0 0 0 2 -2 V14"
}), /*#__PURE__*/React.createElement("line", {
  x1: 10,
  y1: 12,
  x2: 16,
  y2: 12
}), /*#__PURE__*/React.createElement("line", {
  x1: 10,
  y1: 17,
  x2: 19,
  y2: 17
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 22 l3 3 l6 -7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 11 L31 2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 2 H31 V9"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcExternalReconciliation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_external_reconciliation.0a27eee8a01ef80d4e1e183cc0a054e1.svg";